import type { CreateOnKeyDown } from '../../types';
import type { MacroPlaceholderPluginPropertyOptions } from './types';
import { onKeyDownInlineTemplate } from '../common/inlineTemplate';
import isHotkey from 'is-hotkey';
import { Editor, Element, Range } from '../../core';
import { removeMacroPlaceholderAtPath } from './utils';

export const onKeyDownMacroPlaceholder: CreateOnKeyDown<MacroPlaceholderPluginPropertyOptions> =
  ({ pluginID }) =>
  (e: KeyboardEvent, { editor, nodeState }) => {
    const isBackspace = isHotkey('backspace', e);
    const isDelete = isHotkey('delete', e);

    if ((isBackspace || isDelete) && editor.selection != null) {
      let macroPlaceholderEntry =
        Editor.above(editor, {
          at: editor.selection,
          match: (n) => Element.isElement(n) && n.type === pluginID,
          mode: 'lowest',
          voids: true,
        }) ?? undefined;

      // For void chip render mode, a collapsed caret can sit immediately outside the
      // macro placeholder. In that case, treat Backspace/Delete as targeting the adjacent chip.
      if (macroPlaceholderEntry == null && Range.isCollapsed(editor.selection)) {
        const adjacentPoint = isBackspace
          ? Editor.before(editor, editor.selection, { voids: true })
          : Editor.after(editor, editor.selection, { voids: true });

        if (adjacentPoint != null) {
          macroPlaceholderEntry =
            Editor.above(editor, {
              at: adjacentPoint,
              match: (n) => Element.isElement(n) && n.type === pluginID,
              mode: 'lowest',
              voids: true,
            }) ?? undefined;
        }
      }

      if (macroPlaceholderEntry != null) {
        e.preventDefault();
        removeMacroPlaceholderAtPath(editor, macroPlaceholderEntry[1]);
        return true;
      }
    }

    return onKeyDownInlineTemplate({ pluginID })(e, { editor, nodeState });
  };
